import Swal from 'sweetalert2'

$(document).on("turbolinks:load", function () {
  $(document).on('click', '.save_modifier_set_first', function (e) {
    Swal.fire('Oops...', 'Select modifier set and save first!', 'error')
  });

  $(document).on('click', '.duplicate_sub_category', function (e) {
    var url = $(this).data("url");
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will dupliate category with all of its items!',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        window.location = url;
      }
    })
  });

  $(document).on('click', '.duplicate_item', function (e) {
    var url = $(this).data("url");
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will duplicate item with its modifiers and printers!',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        window.location = url;
      }
    })
  });

  $(document).on('click', '.duplicate_modifier_set', function (e) {
    var url = $(this).data("url");
    var shallowCopyMessage = 'This will duplicate the modifier set and its modifiers while keeping existing nested modifier set links.';
    var deepCopyMessage = 'This will duplicate the modifier set along with its modifiers and nested links.';

    Swal.fire({
      title: 'Are you sure?',
      html: `
        <div id="duplicate-modifier-set-message" style="font-size: 15px; line-height: 1.5; margin-bottom: 16px;">
          ${deepCopyMessage}
        </div>
        <label for="duplicate-nested-modifier-sets" style="display: block; text-align: left; padding: 16px; border: 2px solid #f0b429; background: #fff7db; border-radius: 10px; cursor: pointer; margin-top: 6px;">
          <div style="display: flex; align-items: flex-start; gap: 12px;">
            <input id="duplicate-nested-modifier-sets" type="checkbox" checked style="width: 20px; height: 20px; margin-top: 2px; flex-shrink: 0;">
            <div>
              <div style="font-size: 16px; font-weight: 700; color: #7a4b00; margin-bottom: 4px;">Duplicate nested modifier sets too</div>
              <div id="duplicate-nested-modifier-help" style="font-size: 14px; color: #7a4b00; line-height: 1.45;">
                Keep this checked to create copied nested modifier sets during duplication.
              </div>
            </div>
          </div>
        </label>
      `,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel',
      didOpen: () => {
        const checkbox = document.getElementById('duplicate-nested-modifier-sets');
        const messageEl = document.getElementById('duplicate-modifier-set-message');
        const helpEl = document.getElementById('duplicate-nested-modifier-help');
        if (!checkbox || !messageEl || !helpEl) return;

        const syncDuplicateMessage = () => {
          if (checkbox.checked) {
            messageEl.textContent = deepCopyMessage;
            helpEl.textContent = 'Keep this checked to create copied nested modifier sets during duplication.';
          } else {
            messageEl.textContent = shallowCopyMessage;
            helpEl.textContent = 'Uncheck this to reuse the existing nested modifier set links instead of creating copies.';
          }
        };

        syncDuplicateMessage();
        checkbox.addEventListener('change', syncDuplicateMessage);
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const checkbox = document.getElementById('duplicate-nested-modifier-sets');
        const duplicateNestedModifierSets = checkbox ? checkbox.checked : true;
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        window.location = `${url}${separator}duplicate_nested_modifier_sets=${duplicateNestedModifierSets ? 'true' : 'false'}`;
      }
    })
  });

  $(document).on('click', '.transaction_refund', function (e) {
    var url = $(this).data("url");
    Swal.fire({
      title: 'Are you sure?',
      text: 'This will refund to customer!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        window.location = url;
      }
    })
  });

  // change all to this in future
  $(document).on('click', '.sweetalert_by_url', function (e) {
    var url = $(this).data("url");
    var text = $(this).data("message");
    Swal.fire({
      title: 'Are you sure?',
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        window.location = url;
      }
    })
  });

  $(document).on('click', '.global_delete', function (e) {
    var url = $(this).data("url");
    var message = $(this).data("message");
    Swal.fire({
      title: 'Are you sure?',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '#c1c1c1',
      confirmButtonText: 'Yes, Delete!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        $.ajax({
          url: url,
          type: "DELETE"
        }).done(function () {
          location.reload();
        });
      }
    })
  });

  $(document).on('click', '.global_ajax_call_with_alert', function (e) {
    var url = $(this).data("url");
    var warning_message = $(this).data("warning-message");
    Swal.fire({
      title: 'Are you sure?',
      text: warning_message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '#c1c1c1',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        window.location = url
      }
    })
  });

  $(document).on('click', '.gloabal_form_submit', function (e) {
    var url = $(this).data("url");
    var warning_message = $(this).data("warning-message");
    Swal.fire({
      title: 'Are you sure?',
      text: warning_message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '#c1c1c1',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        $("#gloabal_form_submit").submit();
      }
    })
  });

  $(document).on('click', '.refund_charge', function (e) {
    var url = $(this).data("url");
    var warning_message = $(this).data("warning-message");
    Swal.fire({
      title: 'Are you sure?',
      text: warning_message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      cancelButtonColor: '#c1c1c1',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        $("#partial_refund_charge").submit();
      }
    })
  });

  // Send receipt email/SMS from order review
  function sendContact(type, orderId) {
    if (!orderId) { return; }
    var token = document.querySelector('meta[name="csrf-token"]').content;
    fetch(`/orders/send_receipt/${orderId}/${type}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
    })
    .then(function(resp) { return resp.json(); })
    .then(function(json) {
      var msg = json.success || json.message || json.error || "Done";
      showAlert(msg, json.error ? "error" : "success");
    })
    .catch(function() { showAlert("Failed to send " + type.toUpperCase(), "error"); });
  }

  $(document).on("click", ".send-order-email", function() {
    var orderId = $(this).data("order-id");
    sendContact("email", orderId);
  });

  $(document).on("click", ".send-order-sms", function() {
    var orderId = $(this).data("order-id");
    sendContact("sms", orderId);
  });

  function showAlert(message, type) {
    Swal.fire({
      icon: type || 'info',
      title: message,
      confirmButtonText: 'OK'
    });
  }
});
